/** @format */

import styled, { keyframes } from "styled-components"
import {
	CheckBold,
	CloseBold,
	WarningFilled,
	InfoCircleFilled,
} from "@ui-library/icons"

import { colors } from "../../../shared/styles/color"

type ToastProps = {
	type: "success" | "error" | "warning"
	displayed?: boolean
}

const fadeIn = keyframes`
  from {
    right: -360px;
    opacity: 0;
    transform: scale(0.9, 0.9);
  }

  to {
    right: 10px;
    opacity: 1;
    transform: scale(1, 1);
  }
`

const fadeOut = keyframes`
  from {
    right: 10px;
    opacity: 1;
    transform: scale(1, 1);
  }

  to {
    right: -360px;
    opacity: 0;
    transform: scale(0.9, 0.9);
  }
`

export const ToastContainer = styled.div<ToastProps>`
	z-index: 9999;
	position: fixed;
	right: 24px;
	top: 25px;
	display: flex;
	flex-direction: column;
	width: 350px;
	min-height: 91px;
	border-radius: 8px;
	background-color: ${({ type }) =>
		type === "success"
			? colors.C10
			: type === "warning"
			? colors.C09
			: colors.C02};
	transition: right 0.5s ease-in-out,opacity 0.5s ease-in-out,transform 0.5s ease-in-out;
	right:${({ displayed }) => (displayed ? "10px" : "-360px")};
	opacity:${({ displayed }) => (displayed ? "1" : "0")};
	transform::${({ displayed }) =>
		displayed ? "scale(1, 1)" : "scale(0.9, 0.9)"};
`

export const Header = styled.div({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	fontSize: "20px",
	padding: "8px 15px 0 15px",
})

export const HeaderTitle = styled.div<ToastProps>(({ type }) => ({
	alignItems: "center",
	display: "flex",
	fontWeight: "bold",
	fontSize: "20px",
	color:
		type === "success"
			? colors.C03
			: type === "warning"
			? colors.C16
			: colors.C04,
}))

export const CheckIcon = styled(CheckBold)({
	marginRight: "5px",
})

export const ErrorIcon = styled(WarningFilled)({
	marginRight: "5px",
})

export const WarningIcon = styled(InfoCircleFilled)({
	color: colors.C20,
	marginRight: "5px",
})
export const CloseButton = styled(CloseBold)({
	padding: 0,
	width: "15px",
	height: "15px",
	cursor: "pointer",
})

export const Content = styled.div({
	margin: "0px 15px 10px 15px",
	fontSize: "15px",
	fontWeight: 600
})

export const Footer = styled.div({
	position: "absolute",
	bottom: 0,
	width: "350px",
	overflow: "hidden",
})
